import { env, Native } from '@hb/mbridge';
import * as Wechat from '@hb/wechatSDK';
// import nativeMgr from '@/common/native/native';
import {
  isWeixin,
  isEasyBikeApp,
  isHelloFamilyApp,
  isAliMP,
  getAppEnv,
  isBoComTinyApp,
} from '../env/env';
import { uiMgr } from '../uiMgr';
import { appQueryConfig } from './url';
import { invoke } from './wechat';
import logger from './logger';

interface BaseJumpInfo {
  buttonShowAfterPay: string;
  appJumpUrlAfterPay: string;
  aliPayJumpUrlAfterPay: string;
  harmonyJumpUrlAfterPay: string;
  uniqueAppJumpUrlAfterPay: string;
}

declare const tt: any;

interface AppJumpInfo {
  jumpUrlAfterPay: string;
  destAppId?: string;
}

type IJumpInfo = BaseJumpInfo & Record<string, AppJumpInfo | undefined>;

type ExtendedEnv = typeof env & {
  isHarmony: boolean;
  isTTMP: boolean;
}
const extendedEnv = env as ExtendedEnv;

/** 协议开头的链接——http/https:等 */
const SCHEME_RE = /^[^:/]+:\/\//;

/**
 * 在微信中打开h5/原生页面链接
 */
export const jumpWx = (rawUrl: string) => {
  invoke((wx) => {
    const url = SCHEME_RE.test(rawUrl)
      ? `/pages/web-view/web-view?auth=1&url=${encodeURIComponent(rawUrl)}`
      : rawUrl;

    if (wx) {
      wx.miniProgram.navigateTo({ url });
    } else {
      window.location.href = url;
    }
  });
};

// 所有端类型都包含的跳转方法
export const showThirdPage = (rawUrl: string) => {
  if (process.env.VUE_APP_ENV !== 'pro') {
    logger(`[showThirdPage] url '${rawUrl}'`);
  }

  const url = rawUrl.trim();
  const isScheme = SCHEME_RE.test(url);

  if (isWeixin && !isScheme) {
    try {
      const weChatInstance = new Wechat.Wechat();
      weChatInstance.navigator(url);
    } catch (error) {
      logger('err', error);
      logger(error, 'error');
    }

    return;
  }

  if (extendedEnv.isTTMP && !isScheme) {
    try {
      logger('抖音主小程序', url);
      if (url === '/pages/index/index') {
        tt.miniProgram.reLaunch({
          url,
        });
      } else {
        tt.miniProgram.navigateTo({
          url,
        });
      }
    } catch (error) {
      logger(error, 'error');
    }
    return;
  }

  if (env.isAliMP || env.isAliMPMonitor) {
    Native.callNative({
      method: 'goOperationUrlV2',
      params: url,
    });

    return;
  }

  if (isHelloFamilyApp || extendedEnv.isHarmony) {
    Native.openMarketingWeb({ url });
    return;
  }

  window.location.href = url;
};

/**
 * ! 老逻辑
 * 打开第三方页面，打开任何非本单页应用的页面，则都是第三方页面
 * 包括：原生hello app页面，其他h5页面
 */
export const showThirdPageOld = (rawUrl: string) => {
  const url = rawUrl.trim();
  /** 内部跳转scheme */
  const interScheme = 'appBikeMallH5:';

  if (url.indexOf(interScheme) === 0) {
    const name = url.slice(interScheme.length);
    uiMgr.pushPage({ name });
    return;
  }

  showThirdPage(url);
};

const validateAppId = () => {
  const { appId } = appQueryConfig;

  if (appId) {
    if (isWeixin && appId !== 'wxb937e3d0b3ca117e') {
      return false;
    }

    if (isAliMP && appId !== '2017050407110255') {
      return false;
    }
  }

  return true;
};

/**
 * 支付结果页跳转链接
 * @param jumpInfo
 */
export const ticketResultPagejumpLink = (jumpInfo: IJumpInfo) => {
  logger('[bikeMall] 支付结果页跳转链接 jumpInfo', jumpInfo);
  if (!jumpInfo) {
    return;
  }

  // 交银小程序
  if (isBoComTinyApp) {
    uiMgr.showToast({
      message: '购买成功,稍后将充值入你的哈啰账户\n可去哈啰app查看使用',
      duration: 6000,
    });
    return;
  }

  const isMiniProgram = env.isWeixin
    || env.isWechatMini
    || env.isAliMP
    || env.isAliMPMonitor
    || extendedEnv.isTTMP;

  // 租车独立APP
  const isRentApp = env.isHelloRentApp;

  // 小程序全部支持 跳转其他小程序
  let url = '';
  const { appId } = appQueryConfig;

  if (isMiniProgram) {
    if (process.env.VUE_APP_ENV !== 'pro') {
      logger('[ticketResultPagejumpLink] appId', appId);
    }
    const isAli = (env.isAliMP || env.isAliMPMonitor);
    const appJumpInfo = jumpInfo[appId] || { jumpUrlAfterPay: isAli ? jumpInfo.aliPayJumpUrlAfterPay : '' };

    url = appJumpInfo.jumpUrlAfterPay;

    // 微信小程序外部跳转
    if ((isWeixin || env.isWechatMini) && appJumpInfo.destAppId) {
      url = `/pages/navigateToMiniProgram/index?appId=${appJumpInfo.destAppId}&path=${appJumpInfo.jumpUrlAfterPay}`;
    }

    // 抖音小程序跳转
    if (extendedEnv.isTTMP && appJumpInfo.destAppId) {
      logger('跳转抖音外部小程序', url); // tt.miniProgram.navigateTo(url);
    }

    if (!url) {
      uiMgr.showToast('请前往哈啰小程序使用优惠券');
      return;
    }
  } else if (extendedEnv.isHarmony) {
    url = jumpInfo.harmonyJumpUrlAfterPay;
  } else if (isRentApp) {
    url = jumpInfo.uniqueAppJumpUrlAfterPay;
  } else {
    url = jumpInfo.appJumpUrlAfterPay;
  }
  if (!url) {
    logger('[bikeMall] 支付结果页跳转链接 url, url不存在提示文案');
    uiMgr.showToast('请前往哈啰APP使用优惠券');
    return;
  }
  if (env.isAliMP || env.isAliMPMonitor || isEasyBikeApp || extendedEnv.isHarmony) {
    showThirdPageOld(url);
  } else {
    showThirdPage(url);
  }
};

/** 跳转小程序首页 */
export const goCouponPage = () => {
  if (!validateAppId()) {
    uiMgr.showToast('请前往哈啰APP使用优惠券');
    return;
  }

  if (isEasyBikeApp) {
    Native.openMarketingWeb({ url: 'hellobike://hellobike.com/coupon' });
  } else {
    if (env.isHelloHitchApp) {
      Native.openMarketingWeb({ url: 'hellohitch://hellohitch.com/hitch/my/coupon' });
      return;
    }

    if (isWeixin) {
      invoke((wx) => {
        wx.miniProgram.switchTab({ url: '/pages/index/index' });
      });
      return;
    }

    const path: string | null = (() => {
      if (env.isAliMP || env.isAliMPMonitor) {
        return '/pages/index/index';
      }

      return null;
    })();

    if (path) {
      showThirdPage(path);
    }
  }
};

/** 跳转两轮骑行卡列表页 */
export const goTwoWheelCardPage = () => {
  const codeEnv = getAppEnv();
  if (extendedEnv.isHarmony) {
    Native.openMarketingWeb({
      url: `https://m.hellobike.com/AppHelloMiniBrand/${codeEnv === 'pro'
        ? ''
        : `${codeEnv}/`
      }latest/index.html#/pages/index/index?systemCode=68&hideNaviBar=1`,
    });
    return;
  }
  if (isEasyBikeApp) {
    Native.openMarketingWeb({ url: 'hellobike://hellobike.com/moped/business/htr_my_card_page' });
    return;
  }

  const url = `https://m.hellobike.com/AppHelloBikeMainH5/${codeEnv === 'pro'
    ? ''
    : `${codeEnv}/`
  }latest/index.html#/my-cards?adsource=couponmall`;

  if (env.isAliMP || env.isAliMPMonitor) {
    Native.callNative({
      method: 'goOperationUrlV2',
      params: url,
    });
    return;
  }

  if (isWeixin) {
    jumpWx(url);
    return;
  }

  window.location.href = url;
};
